export default __webpack_public_path__ + "static/media/eitaa-dark.8edbd8fd.svg";